import { Identifiable, Project } from "@planzone/dto";
import { Filter } from "@planzone/dto";

function isFilteredByProjects(
  project: Identifiable<Project>,
  { projects }: Filter,
): boolean {
  return (
    !!projects &&
    projects.length > 0 &&
    !projects.find(({ uuid }) => uuid === project.uuid)
  );
}

export { isFilteredByProjects };
